import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTankDishedRoof = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 95.46,
	viewBox: "0 0 100.0 95.46",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 0,
		y: 25.46,
		width: 100,
		height: 70,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 25.46 A 75.0 75.0 0.0 0 1 100.0 25.46 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgTankDishedRoof;
